import { jwtDecode } from "jwt-decode";

type JWTDecodedToken = {
    name: string;
    role: string;
    status: string;
};

export const decodeJwt = (token: string): JWTDecodedToken => {
    return jwtDecode(token);
};

const identityServerBaseUrl = "https://auth.womapp.uk";

async function sendAuthRequest(
    url: string,
    httpMethod: "GET" | "POST" | "DELETE" | "PUT" = "GET",
    body?: any,
    type: "json" | "form-data" = "json"
) {

    const requestParameters = {
        method: httpMethod,
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
            Accept: "application/json",
            "Content-Type": type == "json" ? "application/json" : "application/x-www-form-urlencoded",
        },
        body: getBody(body, type)
    } as RequestInit;

    return fetch(`${identityServerBaseUrl}${url}`, requestParameters,)
        .then(async response => {
            if (response.ok) {
                return response.json();
            }
            console.error("err", response);
            console.error("Error happened during Auth web api request");
            const errorData = await response?.json();

            // ValidationException
            if (errorData?.errors?.entity && errorData?.errors?.entity[0]) {
                return Promise.reject(errorData?.errors?.entity[0]);
            }
            else {
                return Promise.reject(errorData);
            }
        });
}

export default sendAuthRequest;

const getBody = (
    body: any,
    type: "json" | "form-data"
): BodyInit | null | undefined => {
    if (!body) {
        return null;
    }

    if (type == "json") {
        return JSON.stringify(body);
    }
    else if (type == "form-data") {
        let formBody = [];
        for (let property in body) {
            let encodedKey = encodeURIComponent(property);
            let encodedValue = encodeURIComponent(body[property]);
            formBody.push(encodedKey + "=" + encodedValue);
        }

        return formBody.join("&");
    }
};
